'use strict';
module.exports = function (str, length) {
	return str.length > length ? str.slice(0, length) + '...' : str;
};



//////////////////
// WEBPACK FOOTER
// ./~/dots/index.js
// module id = 1154
// module chunks = 0